// =============================================================================
// repereEspaceContexte.js : le CONTEXTE du repère d'espace (26/10/2026), seul
// morceau que lit l'en-tête de page (EnTetePage, bundle principal). Le module
// cloisonné par mutuelle (Conformité : audit interne, contrôle interne,
// Calypso) y pose son <RepereEspace> (src/repereEspace.js, qui voyage avec les
// morceaux paresseux des modules) ; hors d'un tel module, rien.
// =============================================================================
import { createContext, useContext } from "react";

export const RepereEspaceContexte = createContext(null);
/** L'élément du repère fourni par le module (null hors module). */
export const useRepereEspace = () => useContext(RepereEspaceContexte);
